import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="transparent"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6.0013 3.33268L6.0013 3.33935M6.0013 7.99935L6.0013 8.00602M6.0013 12.666L6.0013 12.6727M6.0013 3.99935C5.63311 3.99935 5.33464 3.70087 5.33464 3.33268C5.33464 2.96449 5.63311 2.66602 6.0013 2.66602C6.36949 2.66602 6.66797 2.96449 6.66797 3.33268C6.66797 3.70087 6.36949 3.99935 6.0013 3.99935ZM6.0013 8.66602C5.63311 8.66602 5.33464 8.36754 5.33464 7.99935C5.33464 7.63116 5.63311 7.33268 6.0013 7.33268C6.36949 7.33268 6.66797 7.63116 6.66797 7.99935C6.66797 8.36754 6.36949 8.66602 6.0013 8.66602ZM6.0013 13.3327C5.63311 13.3327 5.33464 13.0342 5.33464 12.666C5.33464 12.2978 5.63311 11.9993 6.0013 11.9993C6.36949 11.9993 6.66797 12.2978 6.66797 12.666C6.66797 13.0342 6.36949 13.3327 6.0013 13.3327Z" />
    <path
      d="M10.0013 3.33268L10.0013 3.33935M10.0013 7.99935L10.0013 8.00602M10.0013 12.666L10.0013 12.6727M10.0013 3.99935C9.63311 3.99935 9.33464 3.70087 9.33464 3.33268C9.33464 2.96449 9.63311 2.66602 10.0013 2.66602C10.3695 2.66602 10.668 2.96449 10.668 3.33268C10.668 3.70087 10.3695 3.99935 10.0013 3.99935ZM10.0013 8.66602C9.63311 8.66602 9.33464 8.36754 9.33464 7.99935C9.33464 7.63116 9.63311 7.33268 10.0013 7.33268C10.3695 7.33268 10.668 7.63116 10.668 7.99935C10.668 8.36754 10.3695 8.66602 10.0013 8.66602ZM10.0013 13.3327C9.63311 13.3327 9.33463 13.0342 9.33463 12.666C9.33463 12.2978 9.63311 11.9993 10.0013 11.9993C10.3695 11.9993 10.668 12.2978 10.668 12.666C10.668 13.0342 10.3695 13.3327 10.0013 13.3327Z"
      strokeWidth="2"
    />
  </svg>
);
